// extracted by mini-css-extract-plugin
export var centered = "_l-6";
export var flexible = "_l-5";
export var footer = "_l-k";
export var footerBorder = "_l-l";
export var header = "_l-c";
export var headerBorder = "_l-d";
export var headerDefault = "_l-g";
export var headerMedium = "_l-h";
export var headerPadding = "_l-e";
export var iconAndTitle = "_l-f";
export var large = "_l-4";
export var largePadding = "_l-a";
export var medium = "_l-3";
export var mediumPadding = "_l-9";
export var modal = "_l-0";
export var modalContainer = "_l-b";
export var noPadding = "_l-7";
export var skinny = "_l-1";
export var small = "_l-2";
export var smallPadding = "_l-8";
export var subtitle = "_l-j";
export var title = "_l-i";